import React from 'react';
import { Box } from '@mui/material';

import { css } from '@emotion/react';
import { styled } from '@mui/material/styles';
import { ConnectionButton } from 'components/Navbar/ConnectButton';
import { NAVBAR } from 'data/navbar';
import { Link } from 'react-router-dom';
import { SOCIAL } from 'data/socials';

const Row = styled('div')`
	display: flex;
	flex-direction: row;
	align-items: center;
	padding: 20px 60px;
	border-right: 1px solid #8a8c92;
`;

const navContainer = css`
	max-height: 82px;
	height: 100%;
	display: flex;
	justify-content: space-between;
	align-items: center;
`;

const Image = styled('img')`
	width: 24px;
	height: 24px;
	position: relative;

	:hover {
		cursor: pointer;
	}

	& img:hover {
		filter: invert(44%) sepia(99%) saturate(6152%) hue-rotate(220deg)
			brightness(95%) contrast(106%);
	}
`;

const StyledLink = styled(Link)(({ theme }) => ({
	color: '#3A3A3A',
	margin: theme.spacing(2),
	cursor: 'pointer',
	textDecoration: 'none',
	fontWeight: 600,
	marginRight: 2,
	'&:hover': {
		color: '#000',
	},
	'&.active': {
		color: '#2960F8',
	},
}));

const StyledAnchor = styled('a')(({ theme }) => ({
	color: '#3A3A3A',
	cursor: 'pointer',
	textDecoration: 'none',
	fontWeight: 500,
	fontSize: 14,
	marginRight: '16px',
	'&:hover': {
		color: '#000',
	},
	'&.active': {
		color: '#2960F8',
	},
}));

const ConnectButton = styled('div')`
	display: flex;
	align-items: center;
	justify-content: center;
	padding: 0 60px;
`;

const SocialAnchor = styled('a')`
	display: contents;
	width: 30px;
	height: 30px;
	position: relative;
	margin: 0 0 0 24px;
	padding: 0;
`;

const SocialWrapper = styled('div')`
	display: flex;
	height: 100%;
	padding: 30px;
	flex-direction: row;
	align-items: center;
	justify-content: center;
	border-right: 1px solid #8a8c92;
	border-left: 1px solid #8a8c92;
`;

const NavContainer = styled(Box)`
	${navContainer};
	background: #f3f3f3;
	border-bottom: 1px solid #8a8c92;
`;

const Navbar: React.ComponentType = () => {
	return (
		<>
			<NavContainer
				sx={{
					position: 'fixed',
					display: 'flex',
					justifyContent: 'space-between',
					zIndex: 3000,
					width: '100%',
				}}
			>
				<Row>
					<Link to={'/'} style={{ display: 'contents' }}>
						<img
							src="/images/rndm-logo.png"
							height={42}
							width={45}
							alt={'movement'}
						/>
					</Link>
				</Row>

				<Box display="flex" alignItems="center">
					<SocialWrapper>
						{NAVBAR.map((d) => {
							return d.target ? (
								<StyledAnchor
									key={d.to}
									target={d.target}
									href={d.to}
								>
									{d.name}
								</StyledAnchor>
							) : (
								<StyledLink key={d.to} to={d.to}>
									{d.name}
								</StyledLink>
							);
						})}
						<Box width={16} />
						<div
							style={{
								display: 'contents',
								alignItems: 'center',
								justifyContent: 'center',
							}}
						>
							{SOCIAL.map((social) => (
								<SocialAnchor
									href={social.url}
									target="_blank"
									key={social.name}
								>
									<Image
										src={social.icon}
										alt={social.name}
										width={24}
										height={24}
										style={{ marginLeft: 24, padding: 0 }}
									/>
								</SocialAnchor>
							))}
						</div>
					</SocialWrapper>
					<ConnectButton>
						<ConnectionButton />
					</ConnectButton>
				</Box>
			</NavContainer>
		</>
	);
};

export { Navbar };
